import serializeParams, { getQueryParamsAsObject } from '@/lib/utils/url';
import validate from '@/lib/utils/validationRules';

const MAX_LENGTH_TEXT = 255;

const ONLY_NUMBER_REG_EXP = /^\d+$/;
const EMAIL_REG_EXP = /([\s\S]+)@([\s\S]+)([.])(\w|\S){2,}$/;
const PHONE_REG_EXP = /^\d([(]{0,1}[0-9]{3}[)]{0,1})(\d{7})$/;

function checkAmount(amount) {
  if (validate.isUndefined(amount)) {
    return false;
  }
  return ONLY_NUMBER_REG_EXP.test(amount);
}

// eslint-disable-next-line no-unused-vars
function checkEmail(email) {
  if (validate.isUndefined(email)) {
    return false;
  }
  return EMAIL_REG_EXP.test(email);
}

// eslint-disable-next-line no-unused-vars
function checkPhone(phone) {
  if (validate.isUndefined(phone)) {
    return false;
  }
  return PHONE_REG_EXP.test(phone);
}

function checkText({ comment, message, address }) {
  if (validate.isNotUndefined(comment)) {
    return comment.length <= MAX_LENGTH_TEXT;
  }
  if (validate.isNotUndefined(message)) {
    return message.length <= MAX_LENGTH_TEXT;
  }
  if (validate.isNotUndefined(address)) {
    return address.length <= MAX_LENGTH_TEXT;
  }
  return false;
}

function getText({ comment, message, address }) {
  if (validate.isNotUndefined(comment)) {
    return { comment };
  }
  if (validate.isNotUndefined(message)) {
    return { message };
  }
  if (validate.isNotUndefined(address)) {
    return { address };
  }
  return null;
}

function checkTipPercents(value) {
  if (validate.isUndefined(value)) {
    return false;
  }

  if (validate.isEmptyString(value)) {
    return false;
  }

  const result = value.split(',')
    .filter(i => Number(i));

  return validate.isNotEmptyArray(result);
}

function getCleanTipPercents(value) {
  const result = value.split(',')
    .filter(i => Number(i));

  if (result.length > 4) {
    result.length = 4;
  }

  return result.join(',');
}

function getFilteredReadonly(values, availableValues = [], valuesSeparator = ',') {
  const preparedValues = values.split(valuesSeparator);
  const filteredValues = preparedValues.filter(value => availableValues.includes(value));
  const joinedValues = filteredValues.join(valuesSeparator);

  return { readonly: joinedValues };
}

function validateURL(parametersMap, readonlyValues) {
  if (validate.isEmptyObject(parametersMap)) {
    return parametersMap;
  }

  const {
    name,
    email,
    phone,
    comment,
    message,
    address,
    amount,
    readonly,
    action,
    orderId,
    description,
    istest,
    tipPercents,
  } = parametersMap;

  const text = { comment, message, address };

  const validatedParametersMap = Object.assign(
    {},
    (checkAmount(amount) && { amount }),
    (validate.isNotUndefined(name) && { name }),
    (validate.isNotUndefined(email) && { email }),
    (validate.isNotUndefined(phone) && { phone }),
    (checkText(text) && getText(text)),
    (validate.isNotUndefined(readonly) && getFilteredReadonly(readonly, readonlyValues)),
    (validate.isNotUndefined(action) && { action }),
    (validate.isPositiveInt(Number(orderId)) && { orderId }),
    (validate.isNotUndefined(description) && { description }),
    (validate.isNotUndefined(istest) && { istest: 1 }),
    (checkTipPercents(tipPercents) && checkAmount(amount) && { tipPercents: getCleanTipPercents(tipPercents) })
  );

  return validatedParametersMap;
}

export function parseURL(availableValues, readonlyValues) {
  const rawString = window.location.search.slice(1);
  const preparedMap = getQueryParamsAsObject(decodeURIComponent(rawString));

  const possibleList = Object.keys(preparedMap).filter(parameter => {
    return availableValues.includes(parameter);
  });

  const filteredMap = possibleList.reduce((acc, curr) => {
    acc[curr] = preparedMap[curr] !== 'undefined' ? preparedMap[curr] : '';
    return acc;
  }, {});

  return validateURL(filteredMap, readonlyValues);
}

export function replaceURL(parametersMap) {
  if (validate.isEmptyObject(parametersMap)) {
    return;
  }

  try {
    window.history.replaceState({}, '', `${window.location.origin}${window.location.pathname}?${serializeParams(parametersMap)}`);
  } catch (error) {
    console.error(error);
  }
}

export function addScript(source) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = source;
  document.head.appendChild(script);
}
